import { PagesControllerAction, PagesControllerActionKeys } from '../actions/pagesController';
import { SourcesAction, SourcesActionKeys } from '../actions/sources';
import { UiAction, UiActionKeys } from '../actions/ui';
import { INITIAL_PAGE, INITIAL_TOTAL_PAGES } from './constants';
import { EditorType } from '../constants';
import { Api } from '../../../typings/api';

export interface PagesControllerState {
	currentSpreadIndex: number;
	prevSpreadIndex: number;
	totalPages: number;
	spreads: number[][];
	displayMode: Api.PublicationDisplayMode;
	firstFrameMode: Api.PublicationFirstFrameMode;
	accessiblePages?: number;
}

const pagesControllerInitialState: PagesControllerState = {
	currentSpreadIndex: 0,
	prevSpreadIndex: 0,
	totalPages: INITIAL_TOTAL_PAGES,
	spreads: [[INITIAL_PAGE]],
	displayMode: Api.PublicationDisplayMode.SLIDER,
	firstFrameMode: Api.PublicationFirstFrameMode.SINGLE,
	accessiblePages: INITIAL_TOTAL_PAGES,
};

export const pagesController = (
	state: PagesControllerState = pagesControllerInitialState,
	action: PagesControllerAction | SourcesAction | UiAction,
): PagesControllerState => {
	switch (action.type) {
		case SourcesActionKeys.SET_DATA: {
			if (action.editorType === EditorType.INDESIGN) {
				const { totalPages, displayMode, firstFrameMode, accessiblePages } = action.data as Api.IndesignEditorGeneralData;
				return {
					...state,
					totalPages,
					displayMode,
					firstFrameMode,
					accessiblePages,
				};
			} else {
				return state;
			}
		}
		case PagesControllerActionKeys.SET_PAGE_SPREADS:
			return {
				...state,
				spreads: action.spreads,
			};
		case PagesControllerActionKeys.CHANGE_PAGE_SPREAD: {
			const spreadIndex = action.spreadIndex && action.spreadIndex >= 0 ? action.spreadIndex : 0;

			return {
				...state,
				currentSpreadIndex: spreadIndex,
				prevSpreadIndex: state.currentSpreadIndex,
			};
		}
		case UiActionKeys.RESET:
			return pagesControllerInitialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/pagesController.ts